/* AUTH */
export const AUTH_LOGIN = 'AUTH_LOGIN'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
/* DASHBOARD */
export const DASHBOARD_LOAD_LOCATION = 'DASHBOARD_LOAD_LOCATION'
/* CATALOG */
export const CATALOG_UPDATE_ITEM = 'CATALOG_UPDATE_ITEM'
export const CATALOG_UPDATE_CATEGORY = 'CATALOG_UPDATE_CATEGORY'
export const CATALOG_GET_ITEMS = 'CATALOG_GET_ITEMS'
export const CATALOG_SHOW_CREATE_ITEM_FORM = 'CATALOG_SHOW_CREATE_ITEM_FORM'
export const CATALOG_SHOW_CREATE_CATEGORY_FORM = 'CATALOG_SHOW_CREATE_CATEGORY_FORM'
/* NOTIFICATION */
export const NOTIFICATION_UPDATE_SUCCESS = 'NOTIFICATION_UPDATE_SUCCESS'
export const NOTIFICATION_UPDATE_ERROR = 'NOTIFICATION_UPDATE_ERROR'